export default __webpack_public_path__ + "static/media/ebics.9a909db7.jpg";